import { EventBusName } from '@/types';

export const EventBus = {
  on<T>(eventType: EventBusName, callback: (data: T) => void): void {
    document.addEventListener(eventType, (event: Event) => {
      const customEvent = event as CustomEvent<T>;
      callback(customEvent.detail);
    });
  },

  dispatch<T>(eventType: EventBusName, data?: T): void {
    const event = new CustomEvent<T>(eventType, { detail: data });
    document.dispatchEvent(event);
  },

  remove<T>(eventType: EventBusName, callback?: (data: T) => void): void {
    document.removeEventListener(eventType, callback as EventListener);
  },
};
